/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull cm-web-app'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 1
 * Build: 1.0.0
 * Runtime: browser:javascript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/trustsaude/M%C3%A9tricas%20CM%20-%20Development/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/trustsaude/M%C3%A9tricas%20CM%20-%20Development/implementation/cm-web-app)
 */

import * as amplitude from '@amplitude/analytics-browser'

/**
 * @typedef BaseEvent
 * @type {object}
 * @property {string} event_type
 * @property {Object.<string, *>} [event_properties]
 */

/**
 * @typedef Plan
 * @type {object}
 * @property {string} [branch]
 * @property {string} [source]
 * @property {string} [version]
 * @property {string} [versionId]
 */

/**
 * @typedef LoadClientOptions
 * @type {object}
 * @property {string} [apiKey]
 * @property {Object} [configuration]
 * @property {BrowserClient} [instance]
 */

/**
 * @typedef LoadOptions
 * @type {object}
 * @property {'metricascmdevelopment'} [environment]
 * @property {boolean} [disabled]
 * @property {LoadClientOptions} [client]
 */

/**
 * @typedef {Object} EventOptions
 * @type {object}
 */

/**
 * @typedef ApiKey
 * @type {object}
 * @property {string} metricascmdevelopment
 */
export const ApiKey = {
	metricascmdevelopment: '',
}

/**
 * @typedef {Object} GrupoTarefas
 * @param {string} dataCriacaoTarefa Data em que foi criada a tarefa sobre a qual incide o evento.
 * @param {string} dataEvento Data do evento.
 * @param {string} [estadoRequisicao] Estado da requisicao no momento da abertura da tarefa
 * @param {string} [idConsulta] No caso da requisição ser do tipo Consulta.
 * @param {string} idProcesso Id do processo que originou o evento.
 * @param {string} [idRequisicao] Id da requisição que originou a tarefa.
 * @param {string} [tipoTarefa] Tipo de tarefa (aprovação consulta, imagiologia,...)
 * @param {string} [userAlocadoTarefa] Nome do utilizador que estava alocado à tarefa no momento do evento.
 */

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration = {
	plan: {
		version: '1',
		branch: 'main',
		source: 'cm-web-app',
		versionId: '60a346d9-b76c-4ae9-a419-0b7740ca22ee',
	},
	...{
		ingestionMetadata: {
			sourceName: 'browser-javascript-ampli',
			sourceVersion: '2.0.0',
		},
	},
}

export class Identify {
	constructor(properties) {
		this.event_type = amplitude.Types.SpecialEventType.IDENTIFY
		this.event_properties = properties
	}
}

export class AbrirTarefa {
	constructor(properties) {
		this.event_type = 'AbrirTarefa'
		this.event_properties = properties
	}
}

export class AdiarTarefa {
	constructor(properties) {
		this.event_type = 'AdiarTarefa'
		this.event_properties = properties
	}
}

export class AnularTarefa {
	constructor(properties) {
		this.event_type = 'AnularTarefa'
		this.event_properties = properties
	}
}

export class AprovarTarefa {
	constructor(properties) {
		this.event_type = 'AprovarTarefa'
		this.event_properties = properties
	}
}

export class CancelarTarefa {
	constructor(properties) {
		this.event_type = 'CancelarTarefa'
		this.event_properties = properties
	}
}

export class EnviarGestor {
	constructor(properties) {
		this.event_type = 'EnviarGestor'
		this.event_properties = properties
	}
}

export class EnviarMedico {
	constructor(properties) {
		this.event_type = 'EnviarMedico'
		this.event_properties = properties
	}
}

export class FecharTarefa {
	constructor(properties) {
		this.event_type = 'FecharTarefa'
		this.event_properties = properties
	}
}

export class RecusarTarefa {
	constructor(properties) {
		this.event_type = 'RecusarTarefa'
		this.event_properties = properties
	}
}

export class ReencaminharTarefa {
	constructor(properties) {
		this.event_type = 'ReencaminharTarefa'
		this.event_properties = properties
	}
}

export class ResolverTarefa {
	constructor(properties) {
		this.event_type = 'ResolverTarefa'
		this.event_properties = properties
	}
}

export class SubmeterTarefa {
	constructor(properties) {
		this.event_type = 'SubmeterTarefa'
		this.event_properties = properties
	}
}

export class TerminarTarefa {
	constructor(properties) {
		this.event_type = 'TerminarTarefa'
		this.event_properties = properties
	}
}

/**
 * @typedef PromiseResult
 * @type {object}
 * @property {Promise|undefined} promise
 */

const getVoidPromiseResult = () => ({ promise: Promise.resolve() })

// prettier-ignore
export class Ampli {
  constructor() {
    /* @type {BrowserClient|undefined} */
    this.amplitude = undefined;
    this.disabled = false;
  }

  /**
   * @return {BrowserClient}
   */
  get client() {
    this.isInitializedAndEnabled();
    return this.amplitude;
  }

  /**
   * @return {boolean}
   */
  get isLoaded() {
    return this.amplitude != null;
  }

  /**
   * @private
   * @return {boolean}
   */
  isInitializedAndEnabled() {
    if (!this.isLoaded) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param {LoadOptions} options Configuration options to initialize the Ampli SDK with. 'environment', 'client.apiKey' or 'client.instance' is required.
   *
   * @return {PromiseResult}
   */
  load(options) {
    this.disabled = options?.disabled ?? false;

    if (this.isLoaded) {
      console.warn('WARNING: Ampli is already initialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey;
    if (options?.client?.apiKey) {
      apiKey = options.client.apiKey;
    } else if (options?.environment) {
      apiKey = ApiKey[options.environment];
    }

    if (options?.client?.instance) {
      this.amplitude = options?.client?.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...options?.client?.configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set or update that user's properties.
   *
   * @param {string|undefined} userId The user's id.
   * @param {Object} [properties] The user's properties.
   * @param {string} [properties.idUtilizador] Property has no description in tracking plan.
   * @param {string} [properties.nomeUtilizador] Nome do utilizador
   * @param {string[]} [properties.rolesUtilizador] Roles / permissões de utilizador
   * @param {EventOptions} [options] Optional event options.
   *
   * @return {PromiseResult}
   */
  identify(userId, properties, options) {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options, user_id: userId};
    }

    const ampIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        ampIdentify.set(key, value);
      }
    }
    return this.amplitude.identify(ampIdentify, options);
  }

  /**
  * Flush the event.
  */
  flush() {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude.flush();
  }

  /**
   * Track event
   *
   * @param {BaseEvent} event The event to track.
   * @param {EventOptions} [options] Optional event options.
   *
   * @return {PromiseResult}
   */
  track(event, options) {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude.track(event, undefined, options);
  }

  /**
   * AbrirTarefa
   *
   * [View in Tracking Plan](https://data.amplitude.com/trustsaude/M%C3%A9tricas%20CM%20-%20Development/events/main/latest/AbrirTarefa)
   *
   * Despoletado quando o utilizador abre a tarefa, seja pelo ecrã inicial ou pelo ecrã do processo
   *
   * Owner: Gabriela Souto
   *
   * @param {Object} properties The event's properties.
   * @param {string} properties.dataCriacaoTarefa Data em que foi criada a tarefa sobre a qual incide o evento.
   * @param {string} properties.dataEvento Data do evento.
   * @param {string} [properties.estadoRequisicao] Estado da requisicao no momento da abertura da tarefa
   * @param {string} [properties.idConsulta] No caso da requisição ser do tipo Consulta.
   * @param {string} properties.idProcesso Id do processo que originou o evento.
   * @param {string} [properties.idRequisicao] Id da requisição que originou a tarefa.
   * @param {string} [properties.tipoTarefa] Tipo de tarefa (aprovação consulta, imagiologia,...)
   * @param {string} [properties.userAlocadoTarefa] Nome do utilizador que estava alocado à tarefa no momento do evento.
   * @param {EventOptions} [options] Options for this track call.
   */
  abrirTarefa(properties, options) {
    return this.track(new AbrirTarefa(properties), options);
  }

  /**
   * AdiarTarefa
   *
   * [View in Tracking Plan](https://data.amplitude.com/trustsaude/M%C3%A9tricas%20CM%20-%20Development/events/main/latest/AdiarTarefa)
   *
   * Desploletado quando o utilizador seleciona a opção 'Adiar' do menu de operações.
   *
   * Owner: Gabriela Souto
   *
   * @param {Object} properties The event's properties.
   * @param {string} properties.dataCriacaoTarefa Data em que foi criada a tarefa sobre a qual incide o evento.
   * @param {string} properties.dataEvento Data do evento.
   * @param {string} [properties.estadoRequisicao] Estado da requisicao no momento da abertura da tarefa
   * @param {string} [properties.idConsulta] No caso da requisição ser do tipo Consulta.
   * @param {string} properties.idProcesso Id do processo que originou o evento.
   * @param {string} [properties.idRequisicao] Id da requisição que originou a tarefa.
   * @param {string} [properties.tipoTarefa] Tipo de tarefa (aprovação consulta, imagiologia,...)
   * @param {string} [properties.userAlocadoTarefa] Nome do utilizador que estava alocado à tarefa no momento do evento.
   * @param {EventOptions} [options] Options for this track call.
   */
  adiarTarefa(properties, options) {
    return this.track(new AdiarTarefa(properties), options);
  }

  /**
   * AnularTarefa
   *
   * [View in Tracking Plan](https://data.amplitude.com/trustsaude/M%C3%A9tricas%20CM%20-%20Development/events/main/latest/AnularTarefa)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string} properties.dataCriacaoTarefa Data em que foi criada a tarefa sobre a qual incide o evento.
   * @param {string} properties.dataEvento Data do evento.
   * @param {string} [properties.estadoRequisicao] Estado da requisicao no momento da abertura da tarefa
   * @param {string} [properties.idConsulta] No caso da requisição ser do tipo Consulta.
   * @param {string} properties.idProcesso Id do processo que originou o evento.
   * @param {string} [properties.idRequisicao] Id da requisição que originou a tarefa.
   * @param {string} [properties.tipoTarefa] Tipo de tarefa (aprovação consulta, imagiologia,...)
   * @param {string} [properties.userAlocadoTarefa] Nome do utilizador que estava alocado à tarefa no momento do evento.
   * @param {EventOptions} [options] Options for this track call.
   */
  anularTarefa(properties, options) {
    return this.track(new AnularTarefa(properties), options);
  }

  /**
   * AprovarTarefa
   *
   * [View in Tracking Plan](https://data.amplitude.com/trustsaude/M%C3%A9tricas%20CM%20-%20Development/events/main/latest/AprovarTarefa)
   *
   * Despoletado quando o utilizador seleciona a opção 'Aprovar' ou 'Submeter'
   *
   * Owner: Gabriela Souto
   *
   * @param {Object} properties The event's properties.
   * @param {string} properties.dataCriacaoTarefa Data em que foi criada a tarefa sobre a qual incide o evento.
   * @param {string} properties.dataEvento Data do evento.
   * @param {string} [properties.estadoRequisicao] Estado da requisicao no momento da abertura da tarefa
   * @param {string} [properties.idConsulta] No caso da requisição ser do tipo Consulta.
   * @param {string} properties.idProcesso Id do processo que originou o evento.
   * @param {string} [properties.idRequisicao] Id da requisição que originou a tarefa.
   * @param {string} [properties.tipoTarefa] Tipo de tarefa (aprovação consulta, imagiologia,...)
   * @param {string} [properties.userAlocadoTarefa] Nome do utilizador que estava alocado à tarefa no momento do evento.
   * @param {EventOptions} [options] Options for this track call.
   */
  aprovarTarefa(properties, options) {
    return this.track(new AprovarTarefa(properties), options);
  }

  /**
   * CancelarTarefa
   *
   * [View in Tracking Plan](https://data.amplitude.com/trustsaude/M%C3%A9tricas%20CM%20-%20Development/events/main/latest/CancelarTarefa)
   *
   * Tarefa cancelada por users admin no separador lateral 'Tarefas'
   *
   * Owner: Gabriela Souto
   *
   * @param {Object} properties The event's properties.
   * @param {string} properties.dataCriacaoTarefa Data em que foi criada a tarefa sobre a qual incide o evento.
   * @param {string} properties.dataEvento Data do evento.
   * @param {string} [properties.estadoRequisicao] Estado da requisicao no momento da abertura da tarefa
   * @param {string} [properties.idConsulta] No caso da requisição ser do tipo Consulta.
   * @param {string} properties.idProcesso Id do processo que originou o evento.
   * @param {string} [properties.idRequisicao] Id da requisição que originou a tarefa.
   * @param {string} [properties.tipoTarefa] Tipo de tarefa (aprovação consulta, imagiologia,...)
   * @param {string} [properties.userAlocadoTarefa] Nome do utilizador que estava alocado à tarefa no momento do evento.
   * @param {EventOptions} [options] Options for this track call.
   */
  cancelarTarefa(properties, options) {
    return this.track(new CancelarTarefa(properties), options);
  }

  /**
   * EnviarGestor
   *
   * [View in Tracking Plan](https://data.amplitude.com/trustsaude/M%C3%A9tricas%20CM%20-%20Development/events/main/latest/EnviarGestor)
   *
   * Despoletado quando o utilizador seleciona a opção 'Enviar Gestor' do menu opções.
   *
   * Owner: Gabriela Souto
   *
   * @param {Object} properties The event's properties.
   * @param {string} properties.dataCriacaoTarefa Data em que foi criada a tarefa sobre a qual incide o evento.
   * @param {string} properties.dataEvento Data do evento.
   * @param {string} [properties.estadoRequisicao] Estado da requisicao no momento da abertura da tarefa
   * @param {string} [properties.idConsulta] No caso da requisição ser do tipo Consulta.
   * @param {string} properties.idProcesso Id do processo que originou o evento.
   * @param {string} [properties.idRequisicao] Id da requisição que originou a tarefa.
   * @param {string} [properties.tipoTarefa] Tipo de tarefa (aprovação consulta, imagiologia,...)
   * @param {string} [properties.userAlocadoTarefa] Nome do utilizador que estava alocado à tarefa no momento do evento.
   * @param {EventOptions} [options] Options for this track call.
   */
  enviarGestor(properties, options) {
    return this.track(new EnviarGestor(properties), options);
  }

  /**
   * EnviarMedico
   *
   * [View in Tracking Plan](https://data.amplitude.com/trustsaude/M%C3%A9tricas%20CM%20-%20Development/events/main/latest/EnviarMedico)
   *
   * Despoletado quando o utilizador seleciona a opção 'Pedir Aprovação' do menu opções.
   *
   * Owner: Gabriela Souto
   *
   * @param {Object} properties The event's properties.
   * @param {string} properties.dataCriacaoTarefa Data em que foi criada a tarefa sobre a qual incide o evento.
   * @param {string} properties.dataEvento Data do evento.
   * @param {string} [properties.estadoRequisicao] Estado da requisicao no momento da abertura da tarefa
   * @param {string} [properties.idConsulta] No caso da requisição ser do tipo Consulta.
   * @param {string} properties.idProcesso Id do processo que originou o evento.
   * @param {string} [properties.idRequisicao] Id da requisição que originou a tarefa.
   * @param {string} [properties.tipoTarefa] Tipo de tarefa (aprovação consulta, imagiologia,...)
   * @param {string} [properties.userAlocadoTarefa] Nome do utilizador que estava alocado à tarefa no momento do evento.
   * @param {EventOptions} [options] Options for this track call.
   */
  enviarMedico(properties, options) {
    return this.track(new EnviarMedico(properties), options);
  }

  /**
   * FecharTarefa
   *
   * [View in Tracking Plan](https://data.amplitude.com/trustsaude/M%C3%A9tricas%20CM%20-%20Development/events/main/latest/FecharTarefa)
   *
   * Fechar na cruz
   *
   * Owner: Gabriela Souto
   *
   * @param {Object} properties The event's properties.
   * @param {string} properties.dataCriacaoTarefa Data em que foi criada a tarefa sobre a qual incide o evento.
   * @param {string} properties.dataEvento Data do evento.
   * @param {string} [properties.estadoRequisicao] Estado da requisicao no momento da abertura da tarefa
   * @param {string} [properties.idConsulta] No caso da requisição ser do tipo Consulta.
   * @param {string} properties.idProcesso Id do processo que originou o evento.
   * @param {string} [properties.idRequisicao] Id da requisição que originou a tarefa.
   * @param {string} [properties.tipoTarefa] Tipo de tarefa (aprovação consulta, imagiologia,...)
   * @param {string} [properties.userAlocadoTarefa] Nome do utilizador que estava alocado à tarefa no momento do evento.
   * @param {EventOptions} [options] Options for this track call.
   */
  fecharTarefa(properties, options) {
    return this.track(new FecharTarefa(properties), options);
  }

  /**
   * RecusarTarefa
   *
   * [View in Tracking Plan](https://data.amplitude.com/trustsaude/M%C3%A9tricas%20CM%20-%20Development/events/main/latest/RecusarTarefa)
   *
   * Despoletado quando o utilizador recusa uma tarefa.
   *
   * Owner: Gabriela Souto
   *
   * @param {Object} properties The event's properties.
   * @param {string} properties.dataCriacaoTarefa Data em que foi criada a tarefa sobre a qual incide o evento.
   * @param {string} properties.dataEvento Data do evento.
   * @param {string} [properties.estadoRequisicao] Estado da requisicao no momento da abertura da tarefa
   * @param {string} [properties.idConsulta] No caso da requisição ser do tipo Consulta.
   * @param {string} properties.idProcesso Id do processo que originou o evento.
   * @param {string} [properties.idRequisicao] Id da requisição que originou a tarefa.
   * @param {string} [properties.tipoTarefa] Tipo de tarefa (aprovação consulta, imagiologia,...)
   * @param {string} [properties.userAlocadoTarefa] Nome do utilizador que estava alocado à tarefa no momento do evento.
   * @param {EventOptions} [options] Options for this track call.
   */
  recusarTarefa(properties, options) {
    return this.track(new RecusarTarefa(properties), options);
  }

  /**
   * ReencaminharTarefa
   *
   * [View in Tracking Plan](https://data.amplitude.com/trustsaude/M%C3%A9tricas%20CM%20-%20Development/events/main/latest/ReencaminharTarefa)
   *
   * Despoletado quando o utilizador reencaminha uma tarefa.
   *
   * Owner: Gabriela Souto
   *
   * @param {Object} properties The event's properties.
   * @param {string} properties.dataCriacaoTarefa Data em que foi criada a tarefa sobre a qual incide o evento.
   * @param {string} properties.dataEvento Data do evento.
   * @param {string} [properties.estadoRequisicao] Estado da requisicao no momento da abertura da tarefa
   * @param {string} [properties.idConsulta] No caso da requisição ser do tipo Consulta.
   * @param {string} properties.idProcesso Id do processo que originou o evento.
   * @param {string} [properties.idRequisicao] Id da requisição que originou a tarefa.
   * @param {string} [properties.tipoTarefa] Tipo de tarefa (aprovação consulta, imagiologia,...)
   * @param {string} [properties.userAlocadoTarefa] Nome do utilizador que estava alocado à tarefa no momento do evento.
   * @param {EventOptions} [options] Options for this track call.
   */
  reencaminharTarefa(properties, options) {
    return this.track(new ReencaminharTarefa(properties), options);
  }

  /**
   * ResolverTarefa
   *
   * [View in Tracking Plan](https://data.amplitude.com/trustsaude/M%C3%A9tricas%20CM%20-%20Development/events/main/latest/ResolverTarefa)
   *
   * Despoletado quando um utilizador resolve uma tarefa (consequência de uma decisão clínica sobre a qual apenas se realiza uma validação por parte do gestor)
   *
   * Owner: Gabriela Souto
   *
   * @param {Object} properties The event's properties.
   * @param {string} properties.dataCriacaoTarefa Data em que foi criada a tarefa sobre a qual incide o evento.
   * @param {string} properties.dataEvento Data do evento.
   * @param {string} [properties.estadoRequisicao] Estado da requisicao no momento da abertura da tarefa
   * @param {string} [properties.idConsulta] No caso da requisição ser do tipo Consulta.
   * @param {string} properties.idProcesso Id do processo que originou o evento.
   * @param {string} [properties.idRequisicao] Id da requisição que originou a tarefa.
   * @param {string} [properties.tipoTarefa] Tipo de tarefa (aprovação consulta, imagiologia,...)
   * @param {string} [properties.userAlocadoTarefa] Nome do utilizador que estava alocado à tarefa no momento do evento.
   * @param {EventOptions} [options] Options for this track call.
   */
  resolverTarefa(properties, options) {
    return this.track(new ResolverTarefa(properties), options);
  }

  /**
   * SubmeterTarefa
   *
   * [View in Tracking Plan](https://data.amplitude.com/trustsaude/M%C3%A9tricas%20CM%20-%20Development/events/main/latest/SubmeterTarefa)
   *
   * Despoletado quando é submetida uma tarefa (ação associada a pareceres e IPP)
   *
   * Owner: Gabriela Souto
   *
   * @param {Object} properties The event's properties.
   * @param {string} properties.dataCriacaoTarefa Data em que foi criada a tarefa sobre a qual incide o evento.
   * @param {string} properties.dataEvento Data do evento.
   * @param {string} [properties.estadoRequisicao] Estado da requisicao no momento da abertura da tarefa
   * @param {string} [properties.idConsulta] No caso da requisição ser do tipo Consulta.
   * @param {string} properties.idProcesso Id do processo que originou o evento.
   * @param {string} [properties.idRequisicao] Id da requisição que originou a tarefa.
   * @param {string} [properties.tipoTarefa] Tipo de tarefa (aprovação consulta, imagiologia,...)
   * @param {string} [properties.userAlocadoTarefa] Nome do utilizador que estava alocado à tarefa no momento do evento.
   * @param {EventOptions} [options] Options for this track call.
   */
  submeterTarefa(properties, options) {
    return this.track(new SubmeterTarefa(properties), options);
  }

  /**
   * TerminarTarefa
   *
   * [View in Tracking Plan](https://data.amplitude.com/trustsaude/M%C3%A9tricas%20CM%20-%20Development/events/main/latest/TerminarTarefa)
   *
   * Ação que termina o ciclo de vida da tarefa, seja recusar, submeter ou resolver.
   *
   * Owner: Gabriela Souto
   *
   * @param {Object} properties The event's properties.
   * @param {string} properties.dataCriacaoTarefa Data em que foi criada a tarefa sobre a qual incide o evento.
   * @param {string} properties.dataEvento Data do evento.
   * @param {string} [properties.estadoRequisicao] Estado da requisicao no momento da abertura da tarefa
   * @param {string} [properties.idConsulta] No caso da requisição ser do tipo Consulta.
   * @param {string} properties.idProcesso Id do processo que originou o evento.
   * @param {string} [properties.idRequisicao] Id da requisição que originou a tarefa.
   * @param {string} [properties.tipoTarefa] Tipo de tarefa (aprovação consulta, imagiologia,...)
   * @param {string} [properties.userAlocadoTarefa] Nome do utilizador que estava alocado à tarefa no momento do evento.
   * @param {EventOptions} [options] Options for this track call.
   */
  terminarTarefa(properties, options) {
    return this.track(new TerminarTarefa(properties), options);
  }
}

export const ampli = new Ampli()
